import { SiteRole } from '@app/shared/enums';
import { IdName } from '@app/shared/models';
import { enumToList } from '../enum-to-list';

const userSiteRoles = [SiteRole.SiteAdministrator, SiteRole.Observer];

export function getSiteRole(value: SiteRole): string {
  switch (value) {
    case SiteRole.SiteAdministrator:
      return 'Site Administrator';
    case SiteRole.Observer:
      return 'Observer';
    case SiteRole.TrainingCoordinator:
      return 'Training Coordinator';
    default:
      throw new Error(`Unsupported value for ProgramRole: ${value}.`);
  }
}

export function getSiteRoleList(): Array<IdName> {
  return enumToList(SiteRole, (value) => getSiteRole(value));
}

export function getProfileSiteRoleList(): Array<IdName> {
  return getRoleList(userSiteRoles);
}

export function getRoleList(roles: SiteRole[]): Array<IdName> {
  return roles.map((role) => new IdName(role, getSiteRole(role)));
}
